import React from "react";
import useAuthenticationStore from "./Store";
import ForgotPassword from "./ForgotPassword";

const ForgottonPasswordCoordinatorContainer: React.FC = () => {
    const { state, dispatch, forgotPassword } = useAuthenticationStore();
    const { email, serverError, isLoading } = state;

    const setEmail = (email: string) => {
        dispatch({ type: "SET_EMAIL", payload: email });
    };

    return (
        <ForgotPassword
            email={email}
            serverError={serverError}
            isLoading={isLoading}
            setEmail={setEmail}
            forgotPassword={forgotPassword}
        />
    );
};

export default ForgottonPasswordCoordinatorContainer;
